module.exports = __webpack_public_path__ + "media/images/zl_zs-677c724cf8245d9d88915bd7ba12bcbf.png";